function initReviewSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--review-initialized')) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 2,
    perMove: 1,
    gap: '20px',
    pagination: true,
    arrows: false,
    drag: true,
    breakpoints: {
      1024: { perPage: 2 },
      575: {
        perPage: 1,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });

  splide.mount();
  slider.classList.add('splide--review-initialized');
}

function autoInitReviewSliders(scope = document) {
  scope.querySelectorAll('.review-splide').forEach((slider) => {
    initReviewSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitReviewSliders());
document.addEventListener('shopify:section:load', (event) =>
  autoInitReviewSliders(event.target)
);
document.addEventListener('shopify:section:select', (event) =>
  autoInitReviewSliders(event.target)
);